class IdleService {
    static get inactiveSeconds() {
        return (new Date() - IdleService.startTime) / 1000;
    }
    
    static resetTimer() {
        IdleService.startTime = new Date();
    };

    static ifInactive(secondsCount, callback) {
        const interval = setInterval(() => {
            if (IdleService.inactiveSeconds >= secondsCount) {
                callback();
                clearInterval(interval);
            }
        }, 1000);
    }
};

IdleService.startTime = new Date();

export default IdleService;